import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import { Plan, PlanesProvider } from './planes';
import { UserDb, User } from './user';

@Injectable()
export class NotificacionesProvider {

    database: firebase.database.Database = firebase.database();
    ruta: string = 'notificaciones';

    constructor(private _planes: PlanesProvider, private _users: User) { }

    allNotyPlan(): Promise<NotyPlan[]> {
        let promise: Promise<NotyPlan[]> = new Promise(resolve => {
            this.database.ref(this.ruta + '/planes').once('value').then(snap => {
                if (snap.exists()) {
                    let temp: NotyPlan[] = [];
                    snap.forEach((s) => {
                        temp.push(s.val());
                    });
                    resolve(temp);
                } else {
                    resolve([]);
                }
            })
        });
        return promise;
    }

    deletePlan(notyPlan: NotyPlan) {
        let promise = new Promise(resolve => {
            this.database.ref(this.ruta + '/planes').child(notyPlan.id).remove();
            this.database.ref(this.ruta + '/usuarios/' + notyPlan.user.id + '/planes').once('value').then(snap => {
                if (snap.exists()) {
                    snap.forEach((s) => {
                        let n = s.val();
                        if(n.id == notyPlan.id){
                            this.database.ref(this.ruta + '/usuarios').child(notyPlan.user.id).child('planes').child(s.key).remove();
                        }
                    });
                    resolve(true);
                } else {
                    resolve(true);
                }
            });
        });
        return promise;
    }

    findPlanesByUser(id: string): Promise<NotyPlan[]> {
        let promise: Promise<NotyPlan[]> = new Promise(resolve => {
            this.database.ref(this.ruta + '/usuarios/' + id + '/planes').once('value').then(snap => {
                if (snap.exists()) {
                    let temp: NotyPlan[] = [];
                    snap.forEach((s) => {
                        temp.push(s.val());
                    });
                    resolve(temp);
                } else {
                    resolve([]);
                }
            });
        });

        return promise;
    }

    storeNotyPlan(noty: NotyPlan) {
        let key = this.database.ref(this.ruta + '/planes').push().key;
        noty.id = key.slice(0);
        this.database.ref(this.ruta + '/planes').child(noty.id).set(noty);
        key = this.database.ref(this.ruta + '/usuarios').child(noty.user.id).child('planes').push().key;
        return this.database.ref(this.ruta + '/usuarios').child(noty.user.id).child('planes').child(key).set(noty);
    }

}

export class NotyPlan {
    accept: boolean;
    id: string;
    plan: Plan;
    user: UserDb;

    constructor(accept: boolean, id: string, plan: Plan, user: UserDb) {
        this.accept = accept;
        this.id = id;
        this.plan = plan;
        this.user = user;
    }
}


// WEBPACK FOOTER //
// ./src/app/providers/notificaciones.ts